// helper functions to toggle a class name on an element
function removeClass(el, classname) {
    if (typeof el === 'undefined') return;
    el.className = el.className.replace(" " + classname, "");
}

function addClass(el, classname) {
    el.className += " " + classname;
}

function hasClass(el, classname) {
    return ((" " + el.className + " ").replace(/[\t\r\n]/g, " ").indexOf(" " + classname + " ") >= 0);
}

// listings
var upcomingListing = document.querySelector('.upcomingEvents');
var pastListing = document.querySelector('.pastEvents');
// button to load more upcoming events
var loadUpcomingBTN = document.getElementById('loadMoreUpcomingBTN');
// button to load more past events
var loadPastBTN = document.getElementById('loadMorePastBTN');

var events = {

    upcomingURL: upcomingListing.getAttribute('data-url'),
    pastURL: pastListing.getAttribute('data-url'),

    updateUpcoming: function () {
        // make the loadmore button disappear
        loadUpcomingBTN.style.display = 'none';
        // var data = new FormData(e.target);
        var xhr = new XMLHttpRequest();

        // add parameters
        var theURL = this.upcomingURL + "&page=" + getNextUpcomingPage();
        xhr.open("GET", theURL);
        //xhr.responseType = "json";
        // Call a function when the state changes.
        xhr.onreadystatechange = function () {
            if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
                var response = this.response;
                if (response == 'false' && upcomingListing.innerText == '') {
                    upcomingListing.innerHTML = '<p class="noevents">No events found...</p>';
                    return;
                }
                if (response == 'false') {
                    return;
                }
                // get last heading of the current events list
                upcomingListing.innerHTML += response;
                loadUpcomingBTN.style.display = '';
                var page = upcomingListing.getAttribute('data-next-page');
                upcomingListing.setAttribute('data-next-page', +page + 1);
            }
        }
        xhr.send();
    },
    updatePast: function () {
        // make the loadmore button disappear
        loadPastBTN.style.display = 'none';
        // var data = new FormData(e.target);
        var xhr = new XMLHttpRequest();

        // add parameters
        var theURL = this.pastURL + "&page=" + getNextPastPage();
        xhr.open("GET", theURL);
        //xhr.responseType = "json";

        // Call a function when the state changes.
        xhr.onreadystatechange = function () {
            if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
                var response = this.response;
                if (response == 'false' && pastListing.innerText == '') {
                    pastListing.innerHTML = '<p class="noevents">No events found...</p>';
                    return;
                }
                if (response == 'false') {
                    return;
                }
                // get last heading of the current events list
                pastListing.innerHTML += response;
                loadPastBTN.style.display = '';
                var page = pastListing.getAttribute('data-next-page');
                pastListing.setAttribute('data-next-page', +page + 1);
            }
        }
        xhr.send();
    }

}

// get current page
function getNextUpcomingPage() {
    return upcomingListing.getAttribute('data-next-page');
}
function getNextPastPage() {
    return pastListing.getAttribute('data-next-page');
}

loadUpcomingBTN.addEventListener('click', function (e) {
    events.updateUpcoming();
})

loadPastBTN.addEventListener('click', function (e) {
    events.updatePast();
})


